import React from 'react'
import { styled } from '@mui/material/styles'
import Link from 'next/link'
import { Link as MLink, Typography } from '@mui/material'
import { config } from 'src/config'
import { AppButton } from '../ui'
import { PrivacyPolicy, TermsOfService } from '@/components/legalInformation'
import Grid from '@mui/material/Grid2'
import { Utils } from '@/lib/utils'

const NEED_HELP_URL = config.helpUrl

const SupportLink = styled('a')`
  text-decoration: underline;
  color: ${({ theme }) => theme.custom.colors.common.green};
`

const StaticResource = styled(MLink)`
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: ${({ theme }) => theme.custom.colors.common.green1};

  & + & {
    margin-left: ${({ theme }) => theme.spacing(2)};
  }
`

const Separated = styled(Typography)`
  margin: 0 ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.custom.colors.common.black};
`

const Separator = () => <Separated>•</Separated>

const TermsAndPrivacy = () => (
  <Grid container justifyContent="center">
    <StaticResource as={TermsOfService} />
    <Separator />
    <StaticResource as={PrivacyPolicy} />
  </Grid>
)

export const HelpBlock: React.FC = () => {
  const formattedPhone = Utils.formatPhoneToDashed(config.customerSupport.phone)

  return (
    <Grid container spacing={2} direction="column" justifyContent="center" alignItems="stretch">
      <Grid>
        <AppButton
          fullWidth
          LinkComponent={Link}
          href={NEED_HELP_URL}
          target="_blank"
          rel="noopener"
          variant="outlined"
        >
          Contact customer support
        </AppButton>
      </Grid>
      <Grid container direction="column" alignItems="center">
        <SupportLink href={`tel:${config.customerSupport.phone}`}>{formattedPhone}</SupportLink>
      </Grid>
      <Grid>
        <TermsAndPrivacy />
      </Grid>
    </Grid>
  )
}
